export default "__VITE_ASSET__Dg1lWyUk__"